import { RootState } from 'store/reducers'

export const selectAccountingActiveDateRange = (store: RootState) =>
  store.accounting.activeDateRange

export const selectAccountingForm = (store: RootState) => store.accounting.form

export const selectAccountingTasks = (store: RootState) =>
  store.accounting.accountingTasks

export const selectRefetchAccountingProcess = (store: RootState) =>
  store.accounting.refetchAccountingProcess

export const selectCurrentAccountingProcess = (store: RootState) =>
  store.accounting.currentAccountingProcess
